module.exports = __webpack_public_path__ + "img/my-task.66f52f68.png";